import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../auth/context/AuthContext';
import { PermissionScopes } from '../../auth/permissions';
import { Conversation } from '../../conversations/types/Conversation';
import { isExternalConversation } from '../../conversations/utils/conversationClassification';
import { useToast } from '../../notifications';
import { CreatePaymentModal } from './CreatePaymentModal';
import detailsStyles from '../../conversations/components/ConversationDetails.module.css';

const conversationContactId = (conversation: Conversation): string | undefined => {
  const withContact = conversation.participants.find(participant => participant.type === 'customer' && participant.contactId)
    ?? conversation.participants.find(participant => participant.contactId);
  return withContact?.contactId;
};

type ConversationRequestPaymentButtonProps = {
  conversation: Conversation;
};

export const ConversationRequestPaymentButton: React.FC<ConversationRequestPaymentButtonProps> = ({ conversation }) => {
  const { t } = useTranslation('payments');
  const { hasPermission } = useAuth();
  const { showToast } = useToast();
  const [open, setOpen] = React.useState(false);
  const canManage = hasPermission(PermissionScopes.paymentsManage);

  if (!canManage || !isExternalConversation(conversation)) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className={detailsStyles.signBtnInline}
        onClick={() => setOpen(true)}
      >
        {t('requestPayment')}
      </button>
      {open ? (
        <CreatePaymentModal
          conversationId={conversation.id}
          contactId={conversationContactId(conversation)}
          sendAfterCreate
          onClose={() => setOpen(false)}
          onCreated={() => {
            showToast(t('linkSent'), 'success');
          }}
        />
      ) : null}
    </>
  );
};
